import client from './client';

export const createConsentTerm = () => client({
	method: 'post',
	url: '/telemedicine/consent-term'
});

export const getConsentTerm = () => client({
	method: 'get',
	url: '/telemedicine/consent-term'
});
